import { Co2Emission } from '@/lib/models/emissions/types';
import { colors } from '@/theme/constants/colors';
import { RadialChartData } from '@/types';

export const transformCo2EmissionToRadialData = (data: Co2Emission): RadialChartData[] => {
  const totalValue = data.wtw;

  return [
    {
      name: 'Well to tank',
      value: data.wtt || 0,
      color: colors.green['100'],
      textColor: '#000000',
      percent: Math.round(((data.wtt || 0) / totalValue) * 100),
    },
    {
      name: 'Tank to wake',
      value: data.ttw || 0,
      color: colors.green['400'],
      textColor: '#ffffff',
      percent: Math.round(((data.ttw || 0) / totalValue) * 100),
    },
  ];
};
